/**
 * "Lampu Meja" (DISCUSSION-sinkron): the installed app's icon carries the number of
 * changes waiting to be sent, through the Badging API. Chrome on Windows and Android show
 * it for installed PWAs; elsewhere the calls do not exist and nothing happens. The count
 * is the ops in the outbox, the same number the chip shows as "n perubahan menunggu
 * dikirim"; zero clears the badge.
 */

export interface BadgeNavigator {
  setAppBadge?: (count?: number) => Promise<void>
  clearAppBadge?: () => Promise<void>
}

export function badgeSupported(nav: BadgeNavigator): boolean {
  return typeof nav.setAppBadge === 'function' && typeof nav.clearAppBadge === 'function'
}

/** Set or clear the badge; resolves false when the API is absent or refused. */
export async function terapkanLencana(nav: BadgeNavigator, jumlah: number): Promise<boolean> {
  if (!badgeSupported(nav)) return false
  try {
    if (jumlah > 0) await nav.setAppBadge?.(Math.floor(jumlah))
    else await nav.clearAppBadge?.()
    return true
  } catch {
    return false
  }
}

/** The badge count: the ops waiting (document uploads are retired, spec 2026-09-30, 9). */
export function jumlahLencana(sync: { pending: number }): number {
  return Math.max(0, sync.pending)
}
